import { render, staticRenderFns } from "./CustomerAmountSummaryDetailList.vue?vue&type=template&id=b482d668&scoped=true&"
import script from "./CustomerAmountSummaryDetailList.vue?vue&type=script&lang=js&"
export * from "./CustomerAmountSummaryDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b482d668",
  null
  
)

export default component.exports